import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import plus_white from "../../../assets/icons/plus_white.svg";

// Components
import Header from "../../../components/Header";
import StoreManagersChart from "../components/StoreManagerChart";
import StoreManagersTable from "../../../tables/StoreManagement/StoreManagersTable";


const StoreManagers = () => {
  const navigate = useNavigate();
  const { 
    statsLoading 
  } = useSelector((state) => state.storeManagement);

  return (
    <>
      {/* Page Header with Add Button */}
      <Header text="Store Manager">
        <button
      onClick={() => navigate('/store-management')}
        className="w-full py-3 flex items-center justify-center px-4 bg-[#2B8C34] rounded-[8px] text-white hover:text-white text-sm font-medium  hover:bg-[#24752B] transition-all"
      >
        <img src={plus_white} alt="plus icon" />
        <p className="text-white font-medium text-sm ml-2">Add Store Manager</p>
      </button>
      </Header>

      {/* Top Section - Chart with Total Count */}
      <div className="mt-6">
        <StoreManagersChart statsLoading={statsLoading} />
      </div>

      {/* Store Managers Table */}
      <div className="mt-6">
        <StoreManagersTable />
      </div>
    </>
  );
};

export default StoreManagers;
